import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "../LandingPage.module.css";
import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useBreakpoints } from "../ResponsiveBreapoints";
import { blogPosts } from "./blogData";

const Blogs = () => {
    const { IsXS, IsSM } = useBreakpoints();
    const navigate = useNavigate();

    const handleReadMore = (slug) => {
        navigate(`/blogs/${slug}`);
        window.scrollTo(0, 0);
    };

    return (
        <Grid container justifyContent="center">
            <Grid
                size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl: 5 }}
                className={styles.contactContainer}
                ml={IsXS ? "" : 3}
            >
                <Grid container rowSpacing={4}>
                    <Grid size={12} className={styles.centerItem} sx={{ flexDirection: "column", gap: 2 }}>
                        <Typography className={styles.aboutUsTitle}>
                            LATEST INSIGHTS
                        </Typography>
                        <Typography className={styles.aboutUsHeading} sx={{ textAlign: 'center' }}>
                            Stay Updated with JP Capital Blogs
                        </Typography>
                    </Grid>

                    {blogPosts.map((post) => (
                        <Grid size={12} key={post.id}>
                            <Box
                                sx={{
                                    padding: '30px',
                                    border: '1px solid #00000026',
                                    borderRadius: '15px',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        borderColor: '#2a75bb',
                                        boxShadow: '0 4px 20px rgba(42, 117, 187, 0.1)'
                                    }
                                }}
                            >
                                <Grid container spacing={IsXS || IsSM ? 2 : 4} alignItems="center">
                                    {!IsXS && !IsSM && post.image && (
                                        <Grid size={{ md: 4, lg: 4 }}>
                                            <Box
                                                component="img"
                                                src={post.image}
                                                alt={post.title}
                                                sx={{
                                                    width: '100%',
                                                    height: '240px',
                                                    objectFit: 'cover',
                                                    borderRadius: '10px',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => handleReadMore(post.slug)}
                                            />
                                        </Grid>
                                    )}
                                    <Grid size={{ xs: 12, sm: 12, md: post.image ? 8 : 12, lg: post.image ? 8 : 12 }}>
                                        <Grid container spacing={2}>
                                            {(IsXS || IsSM) && post.image && (
                                                <Grid size={12}>
                                                    <Box
                                                        component="img"
                                                        src={post.image}
                                                        alt={post.title}
                                                        sx={{
                                                            width: '100%',
                                                            height: '200px',
                                                            objectFit: 'cover',
                                                            borderRadius: '10px',
                                                            cursor: 'pointer',
                                                            mb: 2
                                                        }}
                                                        onClick={() => handleReadMore(post.slug)}
                                                    />
                                                </Grid>
                                            )}
                                            <Grid size={12}>
                                                <Typography
                                                    sx={{
                                                        color: '#2a75bb',
                                                        fontFamily: "Montserrat-600",
                                                        fontSize: '12px',
                                                        letterSpacing: '1px'
                                                    }}
                                                >
                                                    {post.category} • {post.date}
                                                </Typography>
                                            </Grid>
                                            <Grid size={12}>
                                                <Typography
                                                    className={styles.aboutUsHeading}
                                                    sx={{
                                                        fontSize: '22px !important',
                                                        cursor: 'pointer',
                                                        '&:hover': { textDecoration: 'underline' }
                                                    }}
                                                    onClick={() => handleReadMore(post.slug)}
                                                >
                                                    {post.title}
                                                </Typography>
                                            </Grid>
                                            <Grid size={12}>
                                                <Typography className={styles.aboutUsDescription}>
                                                    {post.description}
                                                </Typography>
                                            </Grid>
                                            <Grid size={12}>
                                                <Typography
                                                    sx={{
                                                        color: '#2a75bb',
                                                        fontFamily: "Inter-600",
                                                        fontSize: '14px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        mt: 1,
                                                        '&:hover': { gap: 1.5, transition: 'all 0.2s ease' }
                                                    }}
                                                    onClick={() => handleReadMore(post.slug)}
                                                >
                                                    Read More →
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Blogs;
